import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Grid from "@material-ui/core/Grid";
import makeStyles from "@material-ui/styles/makeStyles";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Typography from "@material-ui/core/Typography";
const useCardStyles = makeStyles(theme => ({
    card: {
        minWidth: 275,
    },
    cardActionsContainer: {
        display: 'flex',
        flexDirection: 'column'
    },
    cardAction:{
        margin:theme.spacing(0),
        marginTop:theme.spacing(2),
        backgroundColor : '#ff1744',
        color : 'white'
    },
    gridMargin :{
        marginBottom: theme.spacing(3),
        marginRight: theme.spacing(2)
    }
}));

const Mobile = ({data,onDelete,onEdit,}) => {
    const classes = useCardStyles();

    const [anchorEl, setAnchorEl] = React.useState(null);


    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleDelete = () => {
        setAnchorEl(null);
        onDelete();
    };

    const handleEdit = () => {
        setAnchorEl(null);
        onEdit();


    };

    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };

    return <Grid item>
        <Card className={classes.card}>
            <CardHeader
                action={
                    <IconButton aria-label="settings" onClick={handleClick}>
                        <MoreVertIcon/>
                    </IconButton>
                }
                title={data.companyName}
            />
            <CardContent>
                    <Grid
                        container
                        justify='space-between'
                        alignItems='flex-end'
                    >
                        <Grid item class={classes.gridMargin}>
                        <Typography variant="h5" component="h2">
                            {data.address}
                        </Typography>
                        <Typography color="textSecondary">
                            Address
                        </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                            <Typography variant="h5" component="h2">
                                {data.paymentTerms}
                            </Typography>
                            <Typography color="textSecondary">
                                Payment Terms
                            </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                            <Typography variant="h5" component="h2">
                                {data.termsAndConditions}
                            </Typography>
                            <Typography color="textSecondary">
                                Terms and Conditions
                            </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                            <Typography variant="h5" component="h2">
                                {data.gstNumber}
                            </Typography>
                            <Typography color="textSecondary">
                                GST Number
                            </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                            <Typography variant="h5" component="h2">
                                {data.bankName}
                            </Typography>
                            <Typography color="textSecondary">
                                Bank Name
                            </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                            <Typography variant="h5" component="h2">
                                {data.accountNumber}
                            </Typography>
                            <Typography color="textSecondary">
                                Account Number
                            </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                            <Typography variant="h5" component="h2">
                                {data.ifscCode}
                            </Typography>
                            <Typography color="textSecondary">
                                IFSC Code
                            </Typography>
                    </Grid>
                    <Grid item class={classes.gridMargin}>
                            <Typography variant="h5" component="h2">
                                {data.branchName}
                            </Typography>
                            <Typography color="textSecondary">
                                Branch Name
                            </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
        <Menu
            id="sales-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
        >
            
            <MenuItem onClick={handleEdit}>Edit</MenuItem>
            <MenuItem onClick={handleDelete}>Delete</MenuItem>
        </Menu>
    </Grid>
};

export default Mobile;